import { useState } from 'react';
import { Budget } from '../../../types';
import { SortDirection, SortField } from '../../../utils/sortUtils';
import BudgetRow from './BudgetRow';
import BudgetsTableHeader from './BudgetsTableHeader';
import BudgetHistoryModal from '../BudgetHistoryModal';
import { BudgetRecipientEnum } from '../../../createAndEdit/types';

interface IBudgetsTableProps {
  budgets: Budget[];
  occurrenceId: string;
  onViewBudget: (budgetId: string, versionNumber?: number) => void;
  onEditBudget?: (budgetId: string, versionNumber?: number) => void;
  sortField: SortField | null;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
  userProfile?: BudgetRecipientEnum | string;
}

const BudgetsTable = (props: IBudgetsTableProps) => {
  const [showHistoryModal, setShowHistoryModal] = useState<boolean>(false);
  const [selectedBudgetId, setSelectedBudgetId] = useState<string | null>(null);

  const handleViewHistory = (budgetId: string) => {
    setSelectedBudgetId(budgetId);
    setShowHistoryModal(true);
  };

  const handleCloseHistoryModal = () => {
    setShowHistoryModal(false);
    setSelectedBudgetId(null);
  };

  return (
    <>
      <div className="mb-8">
        <table className="table table-column-overflow-hidden table-bordered table-head-filled">
          <BudgetsTableHeader
            sortField={props.sortField}
            sortDirection={props.sortDirection}
            onSort={props.onSort}
          />
          <tbody>
            {props.budgets.map((budget) => {
              const hasHistory = budget.hasHistory === true;

              return (
                <BudgetRow
                  key={budget.id}
                  budget={budget}
                  hasHistory={hasHistory}
                  onViewHistory={handleViewHistory}
                  onViewBudget={props.onViewBudget}
                  onEditBudget={props.onEditBudget}
                  userProfile={props.userProfile}
                />
              );
            })}
          </tbody>
        </table>
      </div>

      {selectedBudgetId && (
        <BudgetHistoryModal
          show={showHistoryModal}
          budgetId={selectedBudgetId}
          consultant={props.budgets.find((budget) => budget.id === selectedBudgetId)?.consultantName || "Não identificado"}
          onClose={handleCloseHistoryModal}
          onViewBudget={props.onViewBudget}
          onEditBudget={props.onEditBudget}
          userProfile={props.userProfile}
        />
      )}
    </>
  );
};

export default BudgetsTable;

